import React, { useEffect, useState } from 'react';
import { IContextMenuCheckbox, IContextMenuItem } from '../interfaces/ContextMenu';
import Tippy, { TippyProps } from '@tippyjs/react';
import { ContextMenuComponent } from './ContextMenuComponent';
import { followCursor, hideAll, Instance } from 'tippy.js';
import './styles.scss';

interface CustomContextMenuContainerProps {
    items: Array<IContextMenuItem | IContextMenuCheckbox>;
    className?: string;
    visible?: boolean;
    appendTo?: 'parent' | Element | ((ref: Element) => Element) | undefined;
    onCloseMenu?: () => void;
}

export const CONTEXT_MENU_MAX_WIDTH = 400;

export function CustomContextMenuContainer(props: CustomContextMenuContainerProps & TippyProps) {
    const { items, className, children, visible, onCloseMenu, appendTo, popperOptions } = props;

    const [instance, setInstance] = useState<Instance>();

    const closeMenuHandler = () => {
        hideAll();
    };

    useEffect(() => {
        if (visible) {
            instance?.show();
        } else {
            instance?.hide();
        }
    }, [instance, visible]);

    return (
        <Tippy
            onHidden={() => {
                closeMenuHandler();
            }}
            onHide={() => {
                onCloseMenu && onCloseMenu();
            }}
            onCreate={instance => {
                setInstance(instance);
            }}
            duration={0}
            trigger="manual"
            onClickOutside={() => {
                instance?.hide();
            }}
            followCursor={'initial'}
            placement="right-start"
            plugins={[followCursor]}
            offset={[0, 0]}
            arrow={false}
            interactive
            allowHTML
            theme={'contextMenu'}
            appendTo={appendTo}
            maxWidth={CONTEXT_MENU_MAX_WIDTH}
            content={<ContextMenuComponent items={items} visible={visible} onCloseMenu={closeMenuHandler} />}
            popperOptions={popperOptions}
        >
            <div
                onClick={() => {
                    instance?.hide();
                }}
                onContextMenu={e => {
                    e.preventDefault();
                    visible === undefined && instance?.show();
                }}
                className={`${className}`}
            >
                {children}
            </div>
        </Tippy>
    );
}
